import React from 'react'
import { SearchSmall } from '../icons'

// DEV-2980: the storefront's facet panel head (.fb-menu-multi-head): an
// eyebrow title, then a search field with its icon.

export default function PanelHead({ title, placeholder, query, onQuery }) {
  return (
    <div className="fb-menu-multi-head">
      <span className="fb-menu-multi-title">{title}</span>
      <label className="fb-menu-search">
        <SearchSmall />
        <input
          type="text"
          placeholder={placeholder}
          value={query}
          onChange={(e) => onQuery(e.target.value)}
          aria-label={placeholder}
        />
      </label>
    </div>
  )
}
